import { render, staticRenderFns } from "./img-loader.vue?vue&type=template&id=74abef5a"
import script from "./img-loader.vue?vue&type=script&lang=js"
export * from "./img-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports